module.exports = __webpack_public_path__ + "static/media/group_19.32a1257e.jpg";